import { useCallback, useState } from "react";
import actions from "../../../actions";
import { Performer } from "../Lineup/LineupSection";

const usePerformersSearch = (eventId?: string) => {
  const [searchResults, setSearchResults] = useState<Performer[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const search = useCallback(
    async (query: string) => {
      if (!eventId || !query) return;

      try {
        setIsLoading(true);
        const results = await actions.ADMIN.searchPerformers(eventId, query);
        setSearchResults(results.items);
      } catch (e) {
        console.log("Could not fetch search results", e);
      } finally {
        setIsLoading(false);
      }
    },
    [eventId]
  );

  return {
    search,
    reset: () => setSearchResults([]),
    results: searchResults,
    loading: isLoading,
  };
};

export { usePerformersSearch };
